/* Piegādes logs darba dienās: izlaiž sestdienas, svētdienas un LV svētku dienas.
   Aprēķina pircēja pārlūkā, lai datums neiesprūst lapas kešatmiņā.
   <span data-npt-eta data-min="3" data-max="7">3–7 darba dienās</span> */
(function () {
  var HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-01', '2026-05-04', '2026-06-23', '2026-06-24',
    '2026-11-18', '2026-12-24', '2026-12-25', '2026-12-26', '2026-12-31',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-04', '2027-06-23', '2027-06-24',
    '2027-11-18', '2027-12-24', '2027-12-31'
  ];
  function key(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function workday(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) === -1;
  }
  function addWorkdays(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (workday(d)) n--;
    }
    return d;
  }
  function fmt(d) {
    return String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.';
  }
  function run() {
    document.querySelectorAll('[data-npt-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 3;
      var max = parseInt(el.getAttribute('data-max'), 10) || 7;
      el.textContent = fmt(addWorkdays(min)) + '–' + fmt(addWorkdays(max));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
